/* eslint-disable promise/avoid-new */

const getBatteryManager = async (): Promise<BatteryManager | undefined> => {
  const batteryManager = navigator.getBattery
    ? await navigator.getBattery()
    : undefined;

  return batteryManager;
};

export default getBatteryManager;
